var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitalDisplay3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.89 485.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#4588aa;stroke-miterlimit:10;}.cls-1{stroke-width:5px;}.cls-2{stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "48.89 2.5 106.89 2.5 164.39 60 164.39 142.51 108.89 198.01 108.89 306.5 127.39 325 127.39 410.5 88.64 449.25 35.89 449.25 1.77 483.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.89,
    y1: 16.5,
    x2: 48.89,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 74.89,
    y1: 16.5,
    x2: 58.89,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 84.89,
    y1: 16.5,
    x2: 68.89,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.89,
    y1: 16.5,
    x2: 78.89,
    y2: 32.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalDisplay3);
export default __webpack_public_path__ + "static/media/digitalDisplay3.23796d88edecdf8ac9054728cee79a3d.svg";
export { ForwardRef as ReactComponent };